//
// THIS FILE IS THE ULTIMATE SOURCE OF TRUTH - MODIFY WITH GREAT CAUTION
//
// It defines types for both Variables and Parameters based on the mapping objects.
//
// If you want to add new Variable or Parameter modify the appropriate object, the types will propagate through repository
// and after fixing all TypeScript errors calculators should wrok as expected.
//

type ValueOf<T> = T[keyof T]; // helper

//Mapping values from variables in admin configuration screen
export const selectVariableToParameter = {
  'weather.WindDirection': 'WindDirection',
  'calculators.c.ClubType': 'ClubType',
  'calculators.o.ClubType': 'ClubType',
  'calculators.d.ClubType': 'ClubType',
  'calculators.o.OptimizationType': 'OptimizationType',
  'calculators.o.TrajectoryType': 'TrajectoryType',
  'calculators.b.StimpGreen': 'StimpGreen',
  'calculators.s.SurfaceType': 'SurfaceType',
  'calculators.b.SurfaceType': 'SurfaceType',
  'calculators.s.SurfaceHardness': 'SurfaceHardness',
  'calculators.b.SurfaceHardness': 'SurfaceHardness',
} as const;
export const allSelectVariables = Object.keys(selectVariableToParameter) as SelectVariable[];

export type SelectVariable = keyof typeof selectVariableToParameter;
export type SelectParameter = ValueOf<typeof selectVariableToParameter>;

//Mapping values from variables in admin configuration screen
export const sliderVariableToParameter = {
  'weather.Altitude': 'Altitude',
  'weather.Humidity': 'Humidity',
  'weather.WindVelocity': 'WindSpeed',
  'weather.Temperature': 'Temperature',

  'calculators.c.AttackAngle': 'AttackAngle',
  'calculators.d.AttackAngle': 'AttackAngle',
  'calculators.o.AttackAngle': 'AttackAngle',

  'calculators.s.BallSpeed': 'BallSpeed',

  'calculators.o.ClubSpeed': 'ClubSpeed',
  'calculators.c.ClubSpeed': 'ClubSpeed',

  'calculators.c.ClubPath': 'ClubPath',

  'calculators.c.DynamicLoft': 'DynamicLoft',

  'calculators.c.FaceAngle': 'FaceAngle',

  'calculators.s.LandingHeight': 'LandingHeight',

  'calculators.b.LandingAngle': 'LandingAngle',

  'calculators.o.LaunchAngle': 'LaunchAngle', 
  'calculators.s.LaunchAngle': 'LaunchAngle', 

  'calculators.f.SmashFactor': 'SmashFactor',

  'calculators.s.SpinAxis': 'SpinAxis',

  'calculators.s.SpinRate': 'SpinRate', 

  'calculators.d.SwingDirection': 'SwingDirection',

  'calculators.d.SwingPlane': 'SwingPlane',
} as const;
export const allSliderVariables = Object.keys(sliderVariableToParameter) as SliderVariable[];

export type SliderVariable = keyof typeof sliderVariableToParameter;
export type SliderParameter = ValueOf<typeof sliderVariableToParameter>;

//Mapping values from showData and showDataExtra in admin configuration screen
export const outputVariableToParameter = {
  AttackAngle: 'AttackAngle',
  ClubPath: 'ClubPath',
  Distance: 'Distance',
  FaceAngle: 'FaceAngle',
  'LandingData.Carry': 'Carry',
  'LandingData.CarrySide': 'CarrySide',
  'LandingData.LandingAngle': 'LandingAngle',
  'LandingData.MaxHeight': 'MaxHeight',
  'LandingData.Total': 'Total',
  'LandingData.TotalSide': 'TotalSide',
  'LaunchData.BallSpeed': 'BallSpeed',
  'oo:LaunchData.BallSpeed': 'BallSpeed',
  'fo:BallSpeed': 'BallSpeed',
  'LaunchData.LaunchAngle': 'LaunchAngle',
  'LaunchData.LaunchDirection': 'LaunchDirection',
  'LaunchData.SpinAxis': 'SpinAxis',
  'LaunchData.SpinLoft': 'SpinLoft',
  'LaunchData.SpinRate': 'SpinRate',
  SpinLoft: 'SpinLoft',
  'c:DynamicLoft': 'DynamicLoft',
  'co:FaceToPath': 'FaceToPath',
  FaceToPath: 'FaceToPath',
  'co:SpinLoft': 'SpinLoft',
  'do:AttackAngle': 'AttackAngle',
  'do:ClubPath': 'ClubPath',
  'do:SwingDirection': 'SwingDirection',
  'do:SwingPlane': 'SwingPlane',
  'fo:ClubSpeed': 'ClubSpeed',
  'fo:SmashFactor': 'SmashFactor',
  'oo:LandingData.Carry': 'CarryFlat',
  'oo:LaunchData.SpinLoft': 'SpinLoft',
  'so:LandingData.Carry': 'Carry',
  'so:LandingData.LandingAngle': 'LandingAngle',
  'so:LandingData.LandingBallSpeed': 'LandingBallSpeed',
  'so:LandingData.Total': 'Total',
  'Total': 'Total',
} as const;

export type OutputVariable = keyof typeof outputVariableToParameter;
export type OutputParameter = ValueOf<typeof outputVariableToParameter>;

export const variableToParameter = { ...selectVariableToParameter, ...sliderVariableToParameter, ...outputVariableToParameter };

export type InputVariable = SelectVariable | SliderVariable;
export type NumericVariable = SliderVariable | OutputVariable;
export type Variable = SelectVariable | SliderVariable | OutputVariable;

export type InputParameter = SelectParameter | SliderParameter;
export type NumericParameter = SliderParameter | OutputParameter;
export type Parameter = SelectParameter | SliderParameter | OutputParameter;
